import React from 'react';

const Product3 = () => {
  
};

export default Product3;
